import { FeatureFlagTabs } from '@shared/guards/basic-redirect-to-next-tab.guard';

import { ROUTING_PATH } from '../routingPath';

export const PERIOD_CLOSE_ROUTES_FEATURE_FLAGS: FeatureFlagTabs = {
  [`${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES}`]:
    'tab_invoices',
  [`${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.PREPAIDS}`]:
    'prepaids',
  [ROUTING_PATH.CLOSING.CHECKLIST]: 'checklist_tab',
  [ROUTING_PATH.CLOSING.CLOSE_SUMMARY]: 'month_quarter_close_tab',
  [ROUTING_PATH.CLOSING.EXPENSE_DETAIL]: 'tab_in_month_adjustments',
  [ROUTING_PATH.CLOSING.JOURNAL_ENTRIES]: 'tab_journal_entries',
  [ROUTING_PATH.CLOSING.RECONCILIATION]: 'tab_budget_cash_management',
};
